/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetAdminUserPointsPageListRespVo
 */
export interface GetAdminUserPointsPageListRespVo {
    /**
     * 主键 ID
     * @type {number}
     * @memberof GetAdminUserPointsPageListRespVo
     */
    id?: number;
    /**
     * 用户 ID，关联用户表主键
     * @type {number}
     * @memberof GetAdminUserPointsPageListRespVo
     */
    userId?: number;
    /**
     * 会员名称
     * @type {string}
     * @memberof GetAdminUserPointsPageListRespVo
     */
    name?: string;
    /**
     * 用户账号
     * @type {string}
     * @memberof GetAdminUserPointsPageListRespVo
     */
    code?: string;
    /**
     * 用户等级编号
     * @type {number}
     * @memberof GetAdminUserPointsPageListRespVo
     */
    gradeId?: number;
    /**
     * 用户等级名称
     * @type {string}
     * @memberof GetAdminUserPointsPageListRespVo
     */
    gradeName?: string;
    /**
     * 可用积分
     * @type {number}
     * @memberof GetAdminUserPointsPageListRespVo
     */
    amount?: number;
    /**
     * 冻结积分
     * @type {number}
     * @memberof GetAdminUserPointsPageListRespVo
     */
    freezeAmount?: number;
    /**
     * 已使用积分
     * @type {number}
     * @memberof GetAdminUserPointsPageListRespVo
     */
    usedAmount?: number;
    /**
     * 累计获积分
     * @type {number}
     * @memberof GetAdminUserPointsPageListRespVo
     */
    getAllAmount?: number;
}

/**
 * Check if a given object implements the GetAdminUserPointsPageListRespVo interface.
 */
export function instanceOfGetAdminUserPointsPageListRespVo(value: object): value is GetAdminUserPointsPageListRespVo {
    return true;
}

export function GetAdminUserPointsPageListRespVoFromJSON(json: any): GetAdminUserPointsPageListRespVo {
    return GetAdminUserPointsPageListRespVoFromJSONTyped(json, false);
}

export function GetAdminUserPointsPageListRespVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetAdminUserPointsPageListRespVo {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'userId': json['userId'] == null ? undefined : json['userId'],
        'name': json['name'] == null ? undefined : json['name'],
        'code': json['code'] == null ? undefined : json['code'],
        'gradeId': json['gradeId'] == null ? undefined : json['gradeId'],
        'gradeName': json['gradeName'] == null ? undefined : json['gradeName'],
        'amount': json['amount'] == null ? undefined : json['amount'],
        'freezeAmount': json['freezeAmount'] == null ? undefined : json['freezeAmount'],
        'usedAmount': json['usedAmount'] == null ? undefined : json['usedAmount'],
        'getAllAmount': json['getAllAmount'] == null ? undefined : json['getAllAmount'],
    };
}

export function GetAdminUserPointsPageListRespVoToJSON(json: any): GetAdminUserPointsPageListRespVo {
    return GetAdminUserPointsPageListRespVoToJSONTyped(json, false);
}

export function GetAdminUserPointsPageListRespVoToJSONTyped(value?: GetAdminUserPointsPageListRespVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'userId': value['userId'],
        'name': value['name'],
        'code': value['code'],
        'gradeId': value['gradeId'],
        'gradeName': value['gradeName'],
        'amount': value['amount'],
        'freezeAmount': value['freezeAmount'],
        'usedAmount': value['usedAmount'],
        'getAllAmount': value['getAllAmount'],
    };
}

